import { z, isoZ } from 'my-zod'

export const vehicleMetricModel = z.object({
  id: z.number(),
  engineHours: z.number().nullable(),
  mileage: z.number().nullable(),
  treadDepth: z.number().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  sourceUseCase: z.string().nullable(),
  lastModifiedMetrics: z.string().nullable()
})

export type vehicleMetricModel = z.infer<typeof vehicleMetricModel>

export const getVehicleMetrics = ({
  assetFamilyType,
  productLine
}: {
  assetFamilyType: 'customAssetFamily' | 'modelFamily'
  productLine: string | null
}) => {
  const isProductTypeOnRoad = productLine === 'SLG' || productLine === 'IND'
  if (assetFamilyType === 'customAssetFamily' || !productLine) {
    return []
  }
  const metrics = [
    !isProductTypeOnRoad ? 'hours' : false,
    'fuel',
    'PON' !== productLine ? 'mileage' : false,
    isProductTypeOnRoad ? 'treadDepth32ndInches' : false
  ] as const
  return metrics.filter((m) => m) as Exclude<(typeof metrics)[number], boolean>[]
}

export const isMetricFromTelemetry = (
  metrics: Partial<Pick<any, 'sourceUseCase' | 'lastModifiedMetrics'>> | null | undefined,
  metricName: string
) => {
  return ['PolarisCVC'].includes(metrics?.sourceUseCase) && metrics?.lastModifiedMetrics?.includes(`${metricName}Timestream`)
}
